// Returns false for a user who hasn't registered with us or
// through a third party provider like twitter
export function isRegistered(user) {
  return (
    !!user &&
    (user.registration_status !== 'partial' || user.social_logins.length > 0)
  );
}



// WEBPACK FOOTER //
// ./src/services/userInfoService.js